module.exports = __webpack_public_path__ + "2cfee37a2d9ad0a92d326a99ea07d7a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ii/ii07.jpg
// module id = 653
// module chunks = 0